import { Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

const TooltipElement = ({
    children,
    text,
    translationPrefix,
    position = "top",
    extraStyle
}: {
    children: React.ReactNode;
    text: string;
    translationPrefix?: string;
    position?:
        | "top"
        | "left"
        | "right"
        | "bottom"
        | "topLeft"
        | "topRight"
        | "bottomLeft"
        | "bottomRight"
        | "leftTop"
        | "leftBottom"
        | "rightTop"
        | "rightBottom";
    extraStyle?: React.CSSProperties;
}) => {
    const { t } = useTranslation();

    return (
        <Tooltip
            placement={position || "top"}
            title={translationPrefix ? t(translationPrefix + text) : t(text)}
            color="white"
            overlayClassName="action-icon-tooltip"
            showArrow={true}
            overlayInnerStyle={{ paddingInline: "12px", borderRadius: "8px", ...(extraStyle || {}) }}
        >
            {children}
        </Tooltip>
    );
};

export default TooltipElement;
